import React from 'react';

import DatabaseSvg from 'assets/images/database.svg';

import BaseIcon from './BaseIcon';

const DatabaseIcon = props => (
  <BaseIcon {...props} src={DatabaseSvg} />
);

export default DatabaseIcon;
